import React from 'react';
import clsx from 'clsx';
import { CssBaseline, Typography } from '@mui/material';

import AppButton from '../../../designe/app-button/AppButton';
import { useStyles } from './CommonErrorPage.styles';
import theme from '../../../../styles/theme';

interface ICommonErrorPageProps {
  errorImage: string;
  title: string;
  description: string;
  buttonText: string;
  onClick?: () => void; // Optional function to redirect to home page on button click. Default is to redirect to home page.
}

export default function CommonErrorPage({
  errorImage,
  title,
  description,
  buttonText,
  onClick,
}: ICommonErrorPageProps) {
  const { classes } = useStyles(theme);

  const goToHomePage = () => {
    window.location.href = '/';
  };

  return (
    <div className={classes.container}>
      <CssBaseline />
      <div className={classes.content}>
        <img src={errorImage} alt="" width="400px" height="300px" />
        <div className={classes.mainContent}>
          <Typography variant="h1">{title}</Typography>
          <Typography variant="text-lg" className={clsx(classes.description)}>
            {description}
          </Typography>
          <AppButton
            className={classes.button}
            variant="contained"
            onClick={onClick ? onClick : goToHomePage}>
            {buttonText}
          </AppButton>
        </div>
      </div>
    </div>
  );
}
